import request from '../request';

export const syncRoles = () => request.put(`/sync/roles`).then((res) => res);

export const syncLicenses = () => request.put(`/sync/license`).then((res) => res);
